import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ToolFormTemplate } from '@/templates/BossBaby';
import { useBossBabyTools } from '@/hooks/useBossBaby';
import { CreateBossBabyToolDto } from '@/dto/BossBabyDto';

export const ToolCreate: React.FC = () => {
  const navigate = useNavigate();
  const { createTool } = useBossBabyTools();

  const handleSubmit = async (data: CreateBossBabyToolDto) => {
    try {
      await createTool(data);
    } catch (error) {
      console.error('Create tool error:', error);
    }
  };

  const handleCancel = () => {
    navigate('/boss-baby/tools');
  };

  return (
    <ToolFormTemplate
      onSubmit={handleSubmit}
      onCancel={handleCancel}
      isEdit={false}
    />
  );
};